const { useRef, useEffect } = require("react");

const AnimatedProgressBar = ({ percentage, height = '24px', showText = true, textColor = 'auto', colorScheme = 'abandonment' }) => {
    const progressRef = useRef(null);
    
    useEffect(() => {
      if (progressRef.current) {
        setTimeout(() => {
          if (progressRef.current) {
            progressRef.current.style.width = `${percentage}%`;
          }
        }, 100);
      }
    }, [percentage]);
  
    const getColor = (percentage, scheme) => {
      if (scheme === 'booking') {
        if (percentage >= 70) return '#52c41a';
        if (percentage >= 50) return '#1890ff';
        if (percentage >= 30) return '#faad14';
        return '#ff4d4f';
      } else {
      if (percentage >= 80) return '#ff4d4f';
      if (percentage >= 60) return '#faad14';
      if (percentage >= 40) return '#1890ff';
      return '#52c41a';
      }
    };
  
    const color = getColor(percentage, colorScheme);
    const textColorValue = textColor === 'auto' ? color : textColor;
  
    return (
      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <div style={{ 
          flex: '1 1 0%',
          background: 'rgb(241, 245, 249)',
          borderRadius: '6px',
          overflow: 'hidden',
          height: height, 
          position: 'relative',
          minWidth: 0
        }}>
          <div 
            ref={progressRef}
            style={{ 
              width: '0%', 
              height: '100%', 
              backgroundColor: color,
              borderRadius: '6px',
              transition: 'width 1.2s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          ></div>
        </div>
          {showText && (
            <span 
              style={{ 
              marginLeft: '16px', 
              fontSize: '12px', 
                color: textColorValue,
              fontWeight: 500,
              letterSpacing: '-1px',
              minWidth: '60px',
              textAlign: 'left',
              lineHeight: height,
              userSelect: 'none',
              transition: 'color 0.3s',
              }}
            >
              {percentage.toFixed(1)}%
            </span>
          )}
      </div>
    );
  };

export default AnimatedProgressBar;